import { type FC, useMemo, useRef } from 'react';

import Button from '@/components/DesignLibrary/Button';

import s from './ESignatureModal.module.scss';

type Props = {
  file: File | null;
  setFile: (file: File | null) => void;
  onNextStep: () => void;
};

const ESignatureFileSelection: FC<Props> = ({ file, setFile, onNextStep }) => {
  const documentUploaderRef = useRef<HTMLInputElement>(null);
  const isCtaDisabled = useMemo(() => !file, [file]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const fileInput = e.target.files?.[0];
    if (!fileInput) return;
    setFile(fileInput);
  };

  return (
    <>
      <div className={s.fileSelection}>
        <div className={s.uploadSection}>
          <label>
            <p className={s.labelPrimary}>Upload the document which requires signature</p>
            <p className={s.labelSecondary}>You can annotate where you need the signature in the next step</p>
          </label>
          <div className={s.uploadInputSection}>
            <input
              id='e-sign-hidden-file-input'
              ref={documentUploaderRef}
              className={s.hiddenFileInput}
              type='file'
              accept='application/pdf'
              onChange={handleFileChange}
            />
            <Button variant='secondary' size='sm' onClick={() => documentUploaderRef.current?.click()}>
              {file ? 'Re-upload PDF' : 'Upload PDF'}
            </Button>
            {file && <p className={s.truncatedFileName}>{file.name}</p>}
          </div>
        </div>
        <Button
          className={s.fileSelectionNextCta}
          variant='primary'
          size='md'
          fullWidth
          onClick={onNextStep}
          disabled={isCtaDisabled}
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default ESignatureFileSelection;
